import { render, staticRenderFns } from "./AddLearnerToTeam.vue?vue&type=template&id=78dd2b2e&scoped=true&"
import script from "./AddLearnerToTeam.vue?vue&type=script&lang=js&"
export * from "./AddLearnerToTeam.vue?vue&type=script&lang=js&"
import style0 from "./AddLearnerToTeam.vue?vue&type=style&index=0&id=78dd2b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dd2b2e",
  null
  
)

export default component.exports